export const LoadingIcon = ({ color = '#f97316' }: { color: string }) => {
  return (
    <div role="status">
      <svg
        className="w-5 h-5 animate-spin"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M24.75 12C24.75 18.6274 19.3774 24 12.75 24C6.12258 24 0.75 18.6274 0.75 12C0.75 5.37258 6.12258 0 12.75 0C19.3774 0 24.75 5.37258 24.75 12ZM4.4918 12C4.4918 16.5609 8.18912 20.2582 12.75 20.2582C17.3109 20.2582 21.0082 16.5609 21.0082 12C21.0082 7.43912 17.3109 3.7418 12.75 3.7418C8.18912 3.7418 4.4918 7.43912 4.4918 12Z"
          fill={color}
        />
        <path
          d="M22.8791 12C23.9124 12 24.7649 11.1574 24.6044 10.1367C24.4575 9.20204 24.2003 8.28591 23.8366 7.4078C23.2335 5.95189 22.3496 4.62902 21.2353 3.51472C20.121 2.40042 18.7981 1.5165 17.3422 0.913445C16.4641 0.54972 15.548 0.292459 14.6133 0.145551C13.5926 -0.0148944 12.75 0.837631 12.75 1.8709C12.75 2.90417 13.5981 3.72074 14.6049 3.95283C15.0498 4.05538 15.4865 4.19488 15.9103 4.37042C16.9122 4.78543 17.8226 5.39373 18.5894 6.16057C19.3563 6.92742 19.9646 7.83779 20.3796 8.83972C20.5551 9.26351 20.6946 9.70017 20.7972 10.1451C21.0293 11.1519 21.8458 12 22.8791 12Z"
          fill={color}
        />
      </svg>
    </div>
  );
};
